import { z } from "zod";
import { CLAVES } from "../sat/catalogos.js";
import { ESTADOS_COTIZACION } from "./estados.js";
const monto = z.string().regex(/^\d+(\.\d{1,6})?$/, "monto inválido");
const tasa = z
    .string()
    .regex(/^\d+(\.\d{1,6})?$/, "tasa inválida")
    .nullable()
    .optional();
/**
 * El concepto de cotización es deliberadamente casi idéntico al de factura:
 * cuando el cliente acepta, se copia tal cual. Si divergen, cada aceptación
 * se vuelve una recaptura manual con riesgo de error en montos.
 */
export const conceptoSchema = z.object({
    /** De qué servicio del catálogo salió. Solo rastro: los valores se copian. */
    servicioId: z.uuid().optional(),
    claveProdServ: z.string().min(1).max(20),
    claveUnidad: z.string().min(1).max(20),
    unidad: z.string().max(20).optional(),
    noIdentificacion: z.string().max(100).optional(),
    descripcion: z.string().trim().min(1).max(1000),
    cantidad: monto,
    valorUnitario: monto,
    descuento: monto.optional(),
    objetoImp: z.enum(CLAVES.objetoImp).default("02"),
    tasaIva: tasa.default("0.160000"),
    tasaRetIva: tasa,
    tasaRetIsr: tasa,
    orden: z.number().int().min(0).default(0),
});
export const cotizacionCreateSchema = z.object({
    clienteId: z.uuid(),
    proyectoId: z.uuid().optional(),
    titulo: z.string().trim().min(1).max(200),
    moneda: z.enum(CLAVES.moneda).default("MXN"),
    tipoCambio: monto.optional(),
    validaHasta: z.iso.date(),
    notas: z.string().max(8000).optional(),
    condicionesDePago: z.string().max(1000).optional(),
    conceptos: z.array(conceptoSchema).min(1, "la cotización necesita conceptos"),
});
export const cotizacionUpdateSchema = cotizacionCreateSchema
    .partial()
    .omit({ clienteId: true });
export const cambiarEstadoCotizacionSchema = z.object({
    estado: z.enum(ESTADOS_COTIZACION),
    motivo: z.string().max(1000).optional(),
});
/**
 * Al convertir una cotización en factura, antes se forzaba PUE con
 * FormaPago 03 sin dar opción — no servía para el caso, nada raro, de un
 * cliente que paga en parcialidades. `formaPago` es opcional porque con
 * PPD el backend siempre la fuerza a 99, sin importar lo que llegue aquí.
 */
export const facturarCotizacionSchema = z.object({
    metodoPago: z.enum(CLAVES.metodoPago).default("PUE"),
    formaPago: z.enum(CLAVES.formaPago).optional(),
});
export const listaCotizacionesQuerySchema = z.object({
    clienteId: z.uuid().optional(),
    proyectoId: z.uuid().optional(),
    estado: z.enum(ESTADOS_COTIZACION).optional(),
    desde: z.iso.date().optional(),
    hasta: z.iso.date().optional(),
    limite: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().optional(),
});
//# sourceMappingURL=cotizacion.js.map